import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import App from './App.tsx'
import { AlertProvider } from './components/AlertProvider'
import './index.css'
import './i18n'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

// Google OAuth가 설정되지 않아도 앱 실행 가능
const AppWrapper = GOOGLE_CLIENT_ID ? (
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <AlertProvider>
      <App />
    </AlertProvider>
  </GoogleOAuthProvider>
) : (
  <AlertProvider>
    <App />
  </AlertProvider>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {AppWrapper}
  </React.StrictMode>,
)
